import React from 'react'
import { Count, ScrollAnimation } from 'shared/components'
import { useWindowSize } from 'shared/hooks'
import classes from './Count.module.scss'

export const Counts = (): JSX.Element => {
  const { isLargeDesktop, isDesktop, width } = useWindowSize()
  const items = [
    {
      title: (
        <Count
          number={80}
          duration={2}
          className={classes.count}
          children="+"
        />
      ),
      description: <span className={classes.title}>Оригинальных проектов</span>,
    },
    {
      title: (
        <Count
          number={200}
          duration={2}
          className={classes.count}
          children="+"
        />
      ),
      description: <span className={classes.title}>ТВ-каналов</span>,
    },
    {
      title: (
        <Count
          number={8.6}
          duration={2}
          className={classes.count}
          children="+ МЛН"
        />
      ),
      description: (
        <span className={classes.title}>Пользователей KION в OTT</span>
      ),
    },
    {
      title: <span className={classes.count}>KION</span>,
      description: (
        <a
          className={`${classes.title} link white`}
          href="//devices.kion.ru"
          children="KION на ваших девайсах"
        />
      ),
    },
  ]

  const getMaxHeight = () => {
    if (isLargeDesktop || isDesktop) return 300
    if (width < 720) return 500
    return 300
  }

  return (
    <div className="container">
      <ScrollAnimation
        animatedProp="height"
        classes={`${classes.row__count}`}
        maxHeight={getMaxHeight()}
      >
        <div className="row">
          {items.map((item, itemIndex) => {
            return (
              <div
                className={`${classes.count_item} col-xs-12 col-sm-6 col-md-6 col-lg-3`}
                key={itemIndex}
              >
                <div className={classes.count_item__number}>
                  {item.title}
                  {item.description}
                </div>
              </div>
            )
          })}
        </div>
      </ScrollAnimation>
    </div>
  )
}
